import { IProgramInput } from "@types";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import { FC } from "react";
import CircleClock from "@svg/new-design/circle-clock";
import IconlyBookIcon from "@svg/new-design/bottom-tab-navigation/BookIcon";
import ProgramPageFrame from "assets/image/ProgramPageFrame";
import Image from "next/image";

interface Props {
  data: IProgramInput;
}

const ProgramPageHeader: FC<Props> = ({ data }) => {
  return (
    <div className="py-6 hidden lg:block  lg:py-16 w-full bg-fds-canvas-primary overflow-x-hidden">
      <div className="section-container w-full flex flex-col lg:flex-row-reverse items-center justify-between mx-auto gap-4 px-4     md:px-8   lg:px-12">
        <div className="w-full md:w-1/2 flex justify-center items-center">
          <div className="h-auto w-auto">
            <div className="program-image-container relative flex justify-center">
              <ProgramPageFrame className="w-full aspect-video z-10" />
              <div className="program-image-adjustment aspect-video absolute">
                <Image
                  width={320}
                  height={180}
                  className="object-cover"
                  loading="eager"
                  fetchPriority="high"
                  alt={data.data?.name}
                  src={data.data?.photoUrl}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/2 flex flex-col gap-3">
          <h1 className="text-fds-primary headline-md xl:headline-xlg text-center md:text-right">
            {data.data.name}
          </h1>
          {data.data.content && (
            <div className="body-md xl:body-xlg text-center md:text-right text-fds-primary">
              <div
                dangerouslySetInnerHTML={{ __html: data.data.content || "" }}
              />
            </div>
          )}
          <div className="flex items-center gap-6  justify-center lg:justify-start">
            <div className="flex gap-1 items-center">
              <IconlyBookIcon className="text-fds-icon-brand w-5    lg:w-8" />
              <p className="title-sm xl:title-lg text-fds-secondary">
                {separateMoneyNumbers(
                  toFarsiNumber(data.data.totalUniqueCourses)
                )}
                &nbsp; عنوان آموزشی
              </p>
            </div>
            <div className="flex gap-1 items-center">
              <CircleClock className="text-fds-icon-brand w-5    lg:w-8" />
              <p className="title-sm xl:title-lg text-fds-secondary">
                {separateMoneyNumbers(toFarsiNumber(data.data.totalTime))}
                &nbsp; ساعت
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramPageHeader;
